import { ReactNode } from "react";

import buildings from "@/../../hypetrain/static/img/buildings.svg";
import { Container } from "@/components/pieces/bootstrap";
import { BRAND_PURPLE } from "@/css/constants";

interface BuildingCardProps {
  title: string | ReactNode;
  description: string | ReactNode;
  ctaLink: string;
  ctaText: string | ReactNode;
}

export function BuildingCardInner({
  title,
  description,
  ctaLink,
  ctaText,
}: BuildingCardProps) {
  return (
    <div className="flex rounded-lg border bg-white">
      {/* Content section */}
      <div className="w-full p-4 sm:p-8 md:w-7/12 md:p-10">
        <h2 className="m-0 font-serif text-3xl leading-snug font-light">
          {title}
        </h2>
        <div className="text-lg">{description}</div>
        <div className="mt-3 text-lg">
          <a
            href={ctaLink}
            className="font-semibold"
            style={{ color: BRAND_PURPLE }}
          >
            {ctaText}
          </a>
        </div>
      </div>

      {/* Image set as background image */}
      <div className="relative hidden md:block md:w-5/12">
        <div
          className="absolute top-0 left-0 h-full w-full"
          style={{
            backgroundImage: `url(${buildings})`,
            backgroundPosition: "left center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        />
      </div>
    </div>
  );
}

export function BuildingCard({
  title,
  description,
  ctaLink,
  ctaText,
}: BuildingCardProps) {
  return (
    <Container className="!max-w-marketing-content">
      <div className="py-4 pb-16">
        <BuildingCardInner
          title={title}
          description={description}
          ctaLink={ctaLink}
          ctaText={ctaText}
        />
      </div>
    </Container>
  );
}
